import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ScApiService } from '@sc-ui';
import { LocalizationService } from 'src/services/localization.service';
import { texts } from './project-base.texts';
import { isSalaryHidden } from 'src/services/hidden-salary';

@Component({
  standalone: false,
  selector: 'app-project-base',
  templateUrl: './project-base.component.html',
  styleUrls: ['./project-base.component.scss']
})
export class ProjectBaseComponent implements OnInit {

  texts = texts;

  isSalaryHidden = isSalaryHidden;

  @Input()
  project : any;

  @Output()
  start = new EventEmitter<any>();
  
  users : any = [];

  @ViewChild('editUsersModal')
  editUsersModal : TemplateRef<any>;

  projectSelectedStatus = 'AwaitingOrder';

  editRequirements = false;

  view = '';
  
  constructor(private api : ScApiService, public modalService: NgbModal, public loc : LocalizationService) { }

  ngOnInit() {
  }

  ngOnChanges()
  {
    if (!this.project) return;

    this.api.get(`projects/${this.project.Id}/users`).subscribe(d => {
      this.users = d;
      this.users.forEach(u => {
        u.isAdded = true;
        u.canRemove = !u.IsManager && !u.IsDecider && !u.IsSelf;
      });
    })
  }

  // a project is the customer's to shape until it is ordered. Imported projects (and those in analysis) are
  // the stage before that, so they are editable as well.
  get isEditable()
  {
    return this.project?.Status == 'AwaitingOrder' || this.project?.Status == 'Imported' || this.project?.Status == 'AnalysisRequested';
  }

  // the step the project has completed. Everything up to it lights up, and a status
  // that maps to nothing (Imported, Error, Disqualified) leaves the control empty.
  get progress()
  {
    if (this.project?.Type == 'Longlist')
    {
      switch (this.project?.Status)
      {
        case 'AwaitingOrder': return 'analysis';
        case 'AwaitingSourcing':
        case 'Sourcing':
        case 'Completed': return 'talents';
      }

      return null;
    }

    switch (this.project?.Status)
    {
      case 'AwaitingOrder': return 'analysis';
      case 'AwaitingSourcing':
      case 'Sourcing': return 'outreach';
      case 'Completed': return 'applications';
    }

    return null;
  }

  getImageIndex()
  {
    return this.project.Id % 3 + 1; 
  }

  // the pencil is the only way in and out of the requirements editor. The editor
  // saves on change, so switching back just returns to the read-only list.
  startEdit()
  {
    this.editRequirements = !this.editRequirements;
  }

  showUsersModal()
  {
    this.modalService.open(this.editUsersModal);
  }

  save()
  {
    this.project.Profile.Requirements.forEach(r => r.isSelected = false);
    this.api.put('projects', this.project).subscribe();
  }

}
